import { Directive, Input } from '@angular/core';
import {
	AbstractControl,
	NG_VALIDATORS,
	ValidationErrors,
	Validator,
	ValidatorFn,
} from '@angular/forms';

@Directive({
	selector: '[exactLength]',
	providers: [
		{ provide: NG_VALIDATORS, useExisting: ExactLengthDirective, multi: true },
	],
	standalone: false,
})
export class ExactLengthDirective implements Validator {
	@Input('exactLength') exactLength: number;

	validate(control: AbstractControl): ValidationErrors | null {
		return this.exactLength
			? ExactLengthValidator(this.exactLength)(control)
			: null;
	}
}

export function ExactLengthValidator(exactLength: number): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const { value } = control;

		return !value
			? null
			: value?.length === exactLength
				? null
				: { exactLength: { value: exactLength } };
	};
}
